import ls from 'localstorage-slim';

const textsOnDifferentLangs = {
  en: {
    generalTxt: {
      cancel: "Cancel",
      save: "Save",
      confirm: "Confirm",
      buy: "Buy",
      send: "Send",
      agreement: "I agree with",
      terms: "Terms of Service",
      error: "Error",
      somethingWentWrong: "Something Went Wrong",
      tryAgain: "Try Again",
      upcomingEvents: "Upcoming events",
      info: 'Info',
      memberships: 'Memberships',
      tickets: 'Tickets',
      successOperation: 'Success',
    },
    confirmSaveChanges: {
      title: "Are you sure you want save changes?",
      text: "It’s impossible to take step back then",
      btnConfirm: "Save",
      btnCancel: "Cancel",
    },
    handleOrderStatusesTxt: {
      thanksForYourPurchase: "Thanks for Your Purchase!",
      thanksText1: "We will send all the details to your inbox (",
      thanksText2: ") and look forward to meeting you",
      refusedText: "It seems to have failed to complete the payment, please try again",
    },
    pointsTable: {
      eventNameHeader: "Event Name",
      complexSeatHeader: "Complex Seat",
      pointsHeader: "Points",
      totalPoints: "Total Points",
    },
    preregisterPage: {
      "First name": "First name",
      "Enter your first name": "Enter your first name",
      "Last name": "Last name",
      "Enter your last name": "Enter your last name",
      "Email": "Email",
      "Enter your email": "Enter your email",
      "This is an invalid email": "This is an invalid email",
      "Marketing agreement": "I want to receive information about similar events and offers",
      "Privacy Policy and Terms": "Privacy Policy and Terms",
      "Your info is stored...": "Your information is stored in accordance with GDPR standards. Read the details in the ",
      "Terms of Service": "Terms of Service",
      "and": " and ",
      "Privacy Policy": "Privacy Policy",
      "Submit": "Submit",
      "Event data not received": "Event data not received",
      "Thanks for registration": "Thanks for registration. We connect with you soon.",
      "Registration is failed": "Registration is failed. Please, try again",
    },
    sellPageTxt: {
      chooseYourSeatOnMap: "Choose Your Seat On Map",
      tickets: "Tickets",
      getRuleTitle: (ticketName, count) => `For ${ticketName} from ${count} tickets`,
      getRuleEffectCount: (price, currency) => `Get -${price} ${currency} per ticket`,
      getRuleEffectPercent: (price) => `Get -${price}% `,
      "Select a ticket on the map": "Select a ticket on the map",
      "Add a ticket from the list": "Add a ticket from the list",
      "Enter coupon code": "Enter coupon code",
      "Coupon code": "Coupon code",
      "Buy tickets": "Buy tickets",
      "I agree with": "I agree with ",
      "Payment method": "Payment method",
      "Select Tickets": "Select Tickets",
      "Fill in the info": "Fill in the info",
      "Supported by": "Supported by ",
      "Pay": "Pay",
      "Previous": "Previous",
      "Next": "Next",
      "Contacts": "Contacts",
      "Privacy Policy": "Privacy Policy",
      "Terms of Service": "Terms of Service",
      "have been refunded": "have been refunded",
      "DISCOUNTS": "DISCOUNTS",
    },
    sellPageFieldsTxt: {
      "Full Name": "Full Name",
      "Enter your full name": "Enter your full name",
      "Gender": "Gender",
      "Select your gender": "Select your gender",
      "Birth Date": "Birth Date",
      "Year": "Year",
      "Month": "Month",
      "Day": "Day",
      "Street and House Number": "Street and House Number",
      "Enter your street and house number": "Enter your street and house number",
      "Physical Address": "Physical Address",
      "City": "City",
      "Enter your city": "Enter your city",
      "Postal Code": "Postal Code",
      "Phone Number": "Phone Number",
      "Enter your phone number": "Enter your phone number",
      "Enter your postal code": "Enter your postal code",
      "Buyer Email": "Buyer Email",
      "Enter your email": "Enter your email",
      "This is an invalid email": "This is an invalid email",
      "Company VAT Number": "Company VAT Number",
      "Enter company vat number": "Enter company vat number",
      "Company Name": "Company Name",
      "Enter company company name": "Enter company company name",
      "Male": "Male",
      "Female": "Female",
      "Required Field": "Required Field",
      "Select country": "Select country",
      "Country": "Country",
    },
    choosePaymentMethodTxt: {
      "Ticket receipt": "Ticket receipt",
      "You will receive tickets at": "You will receive tickets at",
      "Please repeat your email address": "Please repeat your email address",
      "Enter your email": "Enter your email",
      "This is an invalid email": "This is an invalid email",
      "Use this email": "Use this email",
      "Email Error": "The entered email address does not match the one previously provided.Please enter a correct email address.",
      "Payment method": "Payment method",
    },
    sellPageModals: {
      "Sales not available": "Sales not available",
      "Tickets sold out": "Tickets sold out",
      "Please wait": "Please wait",
      "You will be redirected to the payment page": "You will be redirected to the payment page",
      "It seems to have failed to complete the payment, please try again": "It seems to have failed to complete the payment, please try again",
      "Thanks for Your Purchase!": "Thanks for Your Purchase!",
      "We will send all the details to your inbox": "We will send all the details to your inbox ",
      " and look forward to meeting you": " and look forward to meeting you",
      "Payment Status: ": "Payment Status: ",
      "Error message: ": "Error message: ",
      "Payment Date: ": "Payment Date: ",
      "Transaction Id: ": "Transaction Id: ",
      "Auth Code: ": "Auth Code: ",
      "Your transaction is in processing": "Your transaction is in processing",
      "Transaction was refunded": "Transaction was refunded",
      "Buy More": "Buy More",
    },
    buyMembershipTxt: {
      online: "Online",
      invoice: "Invoice",
      buyTitle: "Buy Membership",
      buyDescription: "Please make sure you selected the correct type of membership. After payment, we will ask you to assign each membership card to personal data (1 membership card per fan). This membership card does not guarantee a season pass.",
      buyBtn: "Buy",
      nextBtn: "Next",
      cancelBtn: "Cancel",
      buyMembershipsListTitle: "Buy/Extend Membership",
      total: "Total:",
      iAgreeWith: "I agree with",
      termsOfService: "Terms of Service",
      buy: "Buy",
      saveMessage: "Please save changes to buy membership with your valid personal data",
      saveBtn: "Save",
      emptyDataErrorMessage: "All fields are mandatory",
      individualBuyer: "Individual",
      companyBuyer: "Legal company",
      enterCompanyData: "Enter company data",
    },
    waitModalTxt: {
      title: "Please wait",
      description: "You will be redirected to the payment page",
      waitingForReview: "Waiting for review",
    },
    errorModalTxt: {
      description: "It seems to have failed to complete the payment, please try again"
    },
    deleteFileTxt: {
      title: "Are you sure you delete season pass?",
      description: "It’s impossible to take step back then",
      confirmBtn: "Delete",
      cancelBtn: "Cancel",
    },
    dataFormTxt: {
      buyBtn: "Buy",
      personalInfoTitle: "Personal Information",
      personalInfoTitleTooltip: "If you change your data, it does not affect tickets already purchased",
      firstName: "First name",
      "Enter first name": "Enter first name",
      lastName: "Last name",
      "Enter last name": "Enter last name",
      email: "Email address",
      phone: "Phone number",
      streetAndHouse: "Street and House Number",
      city: "City",
      postalCode: "Postal code",
      year: "Year",
      month: "Month",
      day: "Day",
      saveChanges: "Save Changes",
      countrySearchPlaceholder: "Enter country",
      countryNotFound: "No entries to show",
      companyDataTitle: "Fill in company data",
      gender: "Gender",
      male: "Male",
      female: "Female",
    },
    SeasonPassListTxt: {
      title: "Bought Memberships and Season passes",
      spListTitle: "Season Pass List",
      for: "for",
      buySeasonPass: "Buy season pass",
      moveAnotherEmail: "Move to another email",
      seasonPassPurchased: "Season pass purchased",
      buyViaInvoice: "Buy all via invoice",
      toolTipResend: "Resend the ticket",
      tooltipPleaseWait: "Please wait",
      youHaveReservedSeat: "You have a reserved seat",
      changeSeat: "Change seat",
    },
    memberEventsList: {
      "Future events in": "Future events in",
      "Buy tickets": "Buy tickets",
      "Your season passes": "Your season passes",
      "Your tickets": "Your tickets",
      "Buy more tickets": "Buy more tickets",
      "Show more": "Show more",
      "Your tickets on this event": "Your tickets on this event",
      ticketsTooltip: 'If you change your seat, you only need to pay the difference in ticket prices',
      emptyState: 'Stay tuned! New events coming soon.',
      "Season Pass": "Season Pass",
      "Tickets": "Tickets",
      "Cancelled": "Cancelled",
      resaleBlock: {
        "Send to resale": "Send for resale",
        "Selling": "In selling",
        "Sold": "Sold",
        "Total collected": "Total collected",
        "Seat sent to resale": "Seat sent for resale",
        "Seat was not sent for resale": "Seat was not sent for resale",
      },
      resaleApprovePopup: {
        title: "Are you sure you want to submit ticket for sale?",
        text: "This action is irreversible",
        "Send to resale": "Send for resale",
      },
      tooltipMessage: "You can purchase a maximum of 4 day tickets per membership card for 2025/2026.",
      warning: "Warning",
      additionalInfo: 'Additional info',
    },
    EditMembershipCardInfoModalTxt: {
      title: "Edit name and seat",
      placeholder: "Enter name",
      selectedSeat: "Selected seat",
      restoreButtonDescription: "Restore selected seat to default",
      success: "NFC added successfully",
      error: "NFC not added"
    },
    MoveHoldedSeatModalTxt: {
      title: "Share seat to another member",
      placeholder: "Enter email",
      description: "Enter an email address to move this place to another member",
      successOperation: "Please check your email to confirm",
    },
    ChangeSPSeatModalTxt: {
      title: "Change season pass seat",
    },
    ShareSeatModalTxt: {
      title: "Share ticket to another member",
      description: "Enter an email address to move this ticket to another person",
    },
    ChangeTicketSeatModalTxt:{
      title: "Change ticket seat",
    },
    SelectAnotherHoldedSeatModalTxt: {
      title: "Select another reserved seat",
      description: "New seat",
      placeholder: "Select seat",
      selectAnotherHoldedSeat: "Select another seat",
    },
    BuySeasonPassModalTxt: {
      title: "Buy season pass",
      titleNfcOnly: "Buy NFC card",
      buyPhysicalNFCCard: "Buy physical NFC card",
      NFCDescription: "Your pass will be in electronic form, if you want to buy a physical NFC card, click here",
      vatPlaceholder: "Company VAT",
      success: "Email with Tickets sent successfully",
      error: "Email with Tickets not sent",
      seatExpiredError: "The selected seat has expired",
      companyCountryOptions: [
        { label: "Serbia", value: "Serbia" },
        { label: "Other countries", value: "Other countries" },
      ]
    },
    SelectTicketTxt: {
      tickets: "Tickets",
      bookingFee: "Administrative fee",
      processingFee: "Processing fee",
      processingFeeAtLeast: "Processing fee at least",
      fixedFeeRate: "Fixed fee rate",
      usedPoints: "Used points",
      couponDiscount: "Discount from coupon",
      total: "Total",
      row: "Row",
      seat: "Seat",
      includedVAT: 'VAT is included in the price',
    },
    BuyAllSeasonPassesModalTxt: {
      title: "Buy season passes",
      modalDescription: "You receive email with payment information",
      companyNameLabel: "Company name",
      companyNamePlaceholder: "Enter company name",
      companyVatLabel: "Company VAT number",
      companyVatPlaceholder: "Enter VAT number",
      companyAddressLabel: "Company address",
      companyCityPlaceholder: "Enter city",
      companyAddressPlaceholder: "Enter physical address",
      createInvoiceButton: "Request invoice",
      'Exit sale mode': 'Exit sale mode',
    },
    ResentEmail: {
      success: "Email sent successfully",
      error: "Email not sent",
    },
    PersonalInfoUpdating: {
      success: "Data updated successfully",
      error: "Data not updated",
    },
    BuyerPageTxt: {
      'Share ticket': "Share ticket",
      'This ticket is already taken': "This ticket is already taken",
      'Short address error': "Address value is too short. Minimum length is 4"
    }
  },
  rs: {
    generalTxt: {
      cancel: "Otkaži",
      save: "Sačuvaj",
      confirm: "Potvrdi",
      buy: "Kupi",
      send: "Poslati",
      agreement: "Saglasan/na sam",
      terms: "Uslovi korišćenja",
      error: "Greška",
      somethingWentWrong: "Nešto je pošlo po zlu",
      tryAgain: "Pokušajte Ponovo",
      upcomingEvents: "Predstojeći događaji",
      info: 'Info',
      memberships: 'Članske karte',
      tickets: 'Ulaznice',
      successOperation: 'Uspeh',
    },
    confirmSaveChanges: {
      title: "Da li ste sigurni da želite sačuvati izmene?",
      text: "Naknadne izmene neće biti moguće",
      btnConfirm: "Sačuvaj",
      btnCancel: "Otkaži",
    },
    handleOrderStatusesTxt: {
      thanksForYourPurchase: "Uspešna kupovina. Hvala vam!",
      thanksText1: "Poslaćemo vam sve detalje na vašu mail adresu (",
      thanksText2: ") i radujemo se da vas vidimo",
      refusedText: "Kupovina nije uspešna, molimo, pokušajte ponovo",
    },
    pointsTable: {
      eventNameHeader: "Događaj",
      complexSeatHeader: "Sedište",
      pointsHeader: "Poeni",
      totalPoints: "Ukupno poena",
    },
    preregisterPage: {
      "First name": "Ime",
      "Enter your first name": "Unesite svoje ime",
      "Last name": "Prezime",
      "Enter your last name": "Unesite svoje prezime",
      "Email": "E-pošta",
      "Enter your email": "Unesite svoju e-poštu",
      "This is an invalid email": "Ovo je nevažeći e-pošta",
      "Marketing agreement": "Slažem se da mogu primati informacije o ovom i sličnim događajima, kao i relevantnim ponudama vezanim za klub.",
      "Privacy Policy and Terms": "Polisa privatnosti i uslovi",
      "Your info is stored...": "Vaše informacije se čuvaju u skladu sa našim polisama. Detalje pročitajte u ",
      "Terms of Service": "Uslovi korišćenja usluge",
      "and": " i ",
      "Privacy Policy": "Politika Privatnosti",
      "Submit": "Prijavi me",
      "Event data not received": "Podaci o događaju nisu primljeni",
      "Thanks for registration": "Hvala na registraciji. Uskoro ćemo vas kontaktirati.",
      "Registration is failed": "Registracija nije uspela. Molimo pokušajte ponovo.",
    },
    sellPageTxt: {
      chooseYourSeatOnMap: "Izaberite svoje mesto na mapi",
      tickets: "Ulaznice",
      "Select a ticket on the map": "Izaberite kartu na mapi",
      "Add a ticket from the list": "Dodajte kartu sa liste",
      "Enter coupon code": "Unesite kod kupona",
      "Coupon code": "Kod kupona",
      "Buy tickets": "Kupite karte",
      "I agree with": "Slažem se sa odeljkom ",
      "Payment method": "Način plaćanja",
      "Select Tickets": "Izaberite Ulaznice",
      "Fill in the info": "Popunite podatke",
      "Supported by": "Podržano od ",
      "Pay": "Plati",
      "Previous": "Prethodno",
      "Next": "Sledeće",
      "Contacts": "Kontakti",
      "Privacy Policy": "Politika Privatnosti",
      "Terms of Service": "Uslovi korišćenja usluge",
      "have been refunded": "su vraćene",
      "DISCOUNTS": "POPUSTI",
      getRuleTitle: (ticketName, count) => `Za ${count} ${ticketName} karte`,
      getRuleEffectCount: (price, currency) => `dobijate -${price} ${currency} po karti`,
      getRuleEffectPercent: (price) => `Dobijate -${price}%`,
    },
    sellPageFieldsTxt: {
      "Full Name": "Puno ime",
      "Enter your full name": "Unesite svoje puno ime",
      "Gender": "Pol",
      "Select your gender": "Izaberite svoj pol",
      "Birth Date": "Datum rođenja",
      "Year": "Godina",
      "Month": "Mesec",
      "Day": "Dan",
      "Street and House Number": "Ulica i kućni broj",
      "Enter your street and house number": "Unesite svoju ulicu i kućni broj",
      "Physical Address": "Fizička Adresa",
      "City": "Grad",
      "Enter your city": "Unesite svoj grad",
      "Postal Code": "Poštanski broj",
      "Phone Number": "Broj telefona",
      "Enter your phone number": "Unesite svoj broj telefona",
      "Buyer Email": "E-pošta kupca",
      "Enter your email": "Unesite svoju e-poštu",
      "Enter your postal code": "Unesite svoj poštanski broj",
      "This is an invalid email": "Ovo je nevažeći email",
      "Company VAT Number": "PDV broj kompanije",
      "Enter company vat number": "Unesite PDV broj kompanije",
      "Company Name": "Naziv kompanije",
      "Enter company company name": "Unesite naziv kompanije",
      "Male": "Muški",
      "Female": "Ženski",
      "Required Field": "Obavezno polje",
      "Select country": "Odaberi državu",
      "Country": "Država",
    },
    choosePaymentMethodTxt: {
      "Ticket receipt": "Potvrda o prijemu karte",
      "You will receive tickets at": "Ulaznice ćete dobiti na",
      "Please repeat your email address": "Ponovite svoju adresu e-pošte",
      "Enter your email": "Unesite svoju e-poštu",
      "This is an invalid email": "Ovo je nevažeći email",
      "Use this email": "Koristite ovu e-poštu",
      "Email Error": "Uneta adresa e-pošte se ne podudara sa prethodno navedenom. Unesite tačnu adresu e-pošte.",
      "Payment method": "Način plaćanja",
    },
    sellPageModals: {
      "Sales not available": "Prodaja nije dostupna",
      "Tickets sold out": "Ulaznice su rasprodate",
      "Please wait": "Molimo sačekajte",
      "You will be redirected to the payment page": "Bićete preusmereni na stranicu za plaćanje",
      "It seems to have failed to complete the payment, please try again": "Čini se da plaćanje nije uspelo, pokušajte ponovo",
      "Thanks for Your Purchase!": "Hvala na kupovini!",
      "We will send all the details to your inbox": "Sve detalje ćemo vam poslati u inboks ",
      " and look forward to meeting you": " i radujemo se susretu",
      "Payment Status: ": "Status plaćanja: ",
      "Error message: ": "Poruka o grešci: ",
      "Payment Date: ": "Datum plaćanja: ",
      "Transaction Id: ": "ID transakcije: ",
      "Auth Code: ": "Auth Code: ",
      "Your transaction is in processing": "Vaša transakcija je u obradi",
      "Transaction was refunded": "Transakcija je vraćena",
      "Buy More": "Kupi Još Karata",
    },
    buyMembershipTxt: {
      online: "Platite karticom",
      invoice: "Preuzmite predračun",
      buyTitle: "Kupi člansku kartu",
      buyDescription: "Molimo vas da proverite da li ste odabrali odgovarajuće vrste članstva. Nakon plaćanja, zatražićemo od vas da dodelite lične podatke svakoj članskoj karti (jedna članska karta po osobi). (Ukoliko ste vlasnik sezonske ulaznice, kupovinom članske karte imate zagarantovano isto mesto u narednoj sezoni. Ukoliko ne posedujete sezonsku kartu, bićete na prioritetnoj listi za kupovinu nove.)",
      buyBtn: "Kupi",
      nextBtn: "Sledeći",
      cancelBtn: "Otkaži",
      buyMembershipsListTitle: "Kupi člansku kartu 2026/27",
      total: "Ukupno:",
      iAgreeWith: "Slažem se sa odeljkom",
      termsOfService: "Uslovi korišćenja",
      buy: "Kupi",
      saveMessage: "Spremite promjene kako biste kupili članstvo s važećim osobnim podacima",
      saveBtn: "Uštedjeti",
      emptyDataErrorMessage: "Sva polja su obavezna",
      individualBuyer: "Fizičko lice",
      companyBuyer: "Pravno lice",
      enterCompanyData: "Unesite podatke tvrtke",
    },
    waitModalTxt: {
      title: "Molimo sačekajte",
      description: "Bićete preusmereni na stranicu za plaćanje",
      waitingForReview: "Poslato na reviziju!",
    },
    errorModalTxt: {
      description: "Neuspešna kupovina, molimo pokušajte ponovo"
    },
    deleteFileTxt: {
      title: "Da li ste sigurni da želite da obrišete vašu sezonsku kartu?",
      description: "Nakon ovog koraka, naknadne izmene neće biti moguće",
      confirmBtn: "Obriši",
      cancelBtn: "Otkaži",
    },
    dataFormTxt: {
      buyBtn: "Kupi",
      personalInfoTitle: "Lični podaci",
      personalInfoTitleTooltip: 'Ako promenite podatke, to ne utiče na već kupljene karte',
      firstName: "Ime",
      "Enter first name": "Unesite ime",
      lastName: "Prezime",
      "Enter last name": "Unesite prezime",
      email: "E-pošta",
      phone: "Kontakt telefon",
      streetAndHouse: "Ulica i broj",
      city: "Grad",
      postalCode: "Poštanski broj",
      year: "Godina rođenja",
      month: "Mesec",
      day: "Dan",
      saveChanges: "Sačuvaj izmene",
      countrySearchPlaceholder: "Unesite državu",
      countryNotFound: "Nema unosa za prikaz",
      companyDataTitle: "Ispunite podatke o kompaniji",
      gender: "Pol",
      male: "Muški",
      female: "Ženski",
    },
    SeasonPassListTxt: {
      title: "Kupljene članske karte i sezonske propusnice",
      spListTitle: "Sezonske karte",
      for: "za",
      buySeasonPass: "Kupite sezonsku kartu",
      moveAnotherEmail: "Premesti na drugu imejl adresu",
      seasonPassPurchased: "Sezonska karta je kupljena",
      buyViaInvoice: "Kupujte sve preko fakture",
      toolTipResend: "Ponovo pošaljite kartu",
      tooltipPleaseWait: "Molim sačekajte",
      youHaveReservedSeat: "Imate rezervisano mesto",
      changeSeat: "Promeni sedište",
    },
    memberEventsList: {
      "Future events in": "Budući događaji u",
      "Buy tickets": "Kupite karte",
      "Your season passes": "Vaša sezona prolazi",
      "Your tickets": "Vaše karte",
      "Buy more": "Kupi Još Karata",
      "Buy more tickets": "Kupite još karata",
      "Show more": "Pokaži više",
      "Your tickets on this event": "Vaše karte za ovaj događaj",
      ticketsTooltip: "Ako promijenite mesto, potrebno je da platite samo razliku u ceni karata",
      emptyState: 'Ostanite u toku! Uskoro novi događaji.',
      "Season Pass": "Sezonska Karta",
      "Tickets": "Ulaznice",
      "Cancelled": "Otkazano",
      resaleBlock: {
        "Send to resale": "Poslati na preprodaju",
        "Selling": "U prodaji",
        "Sold": "Prodato",
        "Total collected": "Ukupno prikupljeno",
        "Seat sent to resale": "Sedište poslato na preprodaju",
        "Seat was not sent for resale": "Sedište nije poslato na preprodaju",
      },
      resaleApprovePopup: {
        title: "Da li ste sigurni da želite da pošaljete kartu na prodaju?",
        text: "Ova akcija je nepovratna",
        "Send to resale": "Poslati na preprodaju",
      },
      tooltipMessage: "Možete kupiti najviše 4 dnevne ulaznice po jednoj članskoj karti za 2025/2026 godinu.",
      warning: "Upozorenje",
      additionalInfo: 'Dodatne informacije',
    },
    EditMembershipCardInfoModalTxt: {
      title: "Izmeni ime i sedište",
      placeholder: "Unesite ime",
      selectedSeat: "Izabrano sedište",
      restoreButtonDescription: "Vrati izabrano sedište na podrazumevano",
      success: "NFC je uspešno dodan",
      error: "NFC nije dodan"
    },
    MoveHoldedSeatModalTxt: {
      title: "Deli mesto drugom članu",
      placeholder: "Unesite email adresu",
      description: "Unesite email adresu da biste poslali ovo mesto drugom članu",
      successOperation: "Molimo vas da proverite svoju poštu da biste potvrdili",
    },
    ChangeSPSeatModalTxt: {
      title: "Promena mesta za sezonsku kartu",
    },
    ShareSeatModalTxt: {
      title: "Deli sedište drugom članu",
      description: "Unesite adresu e-pošte da biste premestili ovu kartu drugoj osobi",
    },
    ChangeTicketSeatModalTxt: {
      title: "Promena mesta za kartu",
    },
    SelectAnotherHoldedSeatModalTxt: {
      title: "Izaberite drugo rezervisano sedište",
      description: "Novo sedište",
      placeholder: "Izaberite sedište",
      selectAnotherHoldedSeat: "Izaberite drugo sedište",
    },
    BuySeasonPassModalTxt: {
      title: "Kupite sezonsku kartu",
      titleNfcOnly: "Kupite NFC karticu",
      buyPhysicalNFCCard: "Kupite fizičku NFC karticu",
      NFCDescription: "Za korišćenje vaše Wallet karte, neophodno je da vaš mobilni uređaj podržava NFC. U suprotnom, obavezno poručite fizičku NFC karticu.",
      vatPlaceholder: "PIB",
      success: "E-pošta s ulaznicama je uspešno poslana",
      error: "E-pošta s ulaznicama nije poslana",
      seatExpiredError: "Izabrano sedište je isteklo",
      companyCountryOptions: [
        { label: "Srbija", value: "Srbija" },
        { label: "Druge zemlje", value: "Druge zemlje" },
      ]
    },
    SelectTicketTxt: {
      tickets: "Ulaznice",
      bookingFee: "Administrativna taksa",
      processingFee: "Naknada za obradu",
      processingFeeAtLeast: "Najmanje naknada za obradu",
      usedPoints: "Iskorišćeni bodovi",
      couponDiscount: "Popust sa kupona",
      total: "Ukupno",
      row: "Red",
      seat: "Sediste",
      includedVAT: 'U cenu je uračunat PDV',
    },
    BuyAllSeasonPassesModalTxt: {
      title: "Kupite sezonske karte",
      modalDescription: "Dobijate imejl sa informacijama o plaćanju",
      companyNameLabel: "Naziv kompanije",
      companyNamePlaceholder: "Unesite naziv kompanije",
      companyVatLabel: "Poreski identifikacioni broj PIB (VAT)",
      companyVatPlaceholder: "Unesite PIB broj",
      companyAddressLabel: "Adresa kompanije",
      companyCityPlaceholder: "Unesite grad",
      companyAddressPlaceholder: "Unesite fizičku adresu",
      createInvoiceButton: "Zahtevajte fakturu",
      'Exit sale mode': 'Izađi iz režima prodaje',
    },
    ResentEmail: {
      success: "E-pošta je uspešno poslana",
      error: "E-pošta nije poslana",
    },
    PersonalInfoUpdating: {
      success: "Podaci su uspešno ažurirani",
      error: "Podaci nisu ažurirani",
    },
    BuyerPageTxt: {
      'Share ticket': "Deli kartu",
      'This ticket is already taken': "Ova karta je već zauzeta",
      'Short address error': "Vrednost adrese je prekratka. Minimalna dužina je 4"
    }
  },
};

const allowedUrls = [
  "member",
  "events",
  "offers",
  "iframe",
  "preregisters",
  "share-ticket",
];

export const languagesList = [
  { label: "EN", value: "en" },
  { label: "RS", value: "rs" },
];

export const getLangCode = () => {
  for (const url of allowedUrls) {
    if (window.location.href.includes(url)) {
      return ls.get('targetLang') || 'en';
    }
  }

  return 'en';
}

export const setLangCode = (langCode) => {
  ls.set('targetLang', langCode)
}

export function getCurrentLanguageTexts(langCode = '') {
  let lang = langCode ? langCode : getLangCode();

  if (textsOnDifferentLangs[lang] === undefined) {
    lang = 'en';
  }

  return textsOnDifferentLangs[lang];
}